/**
 * FR-015-145: the document `dir` follows the resolved locale. `Intl.Locale#getTextInfo`
 * answers where the engine ships it; the script-based fallback covers the rest of the
 * supported browser set.
 */
const RTL_SCRIPTS = new Set(["Arab", "Hebr", "Syrc", "Thaa", "Nkoo", "Adlm", "Rohg", "Mand", "Samr"]);
const RTL_LANGUAGES = new Set(["ar", "he", "fa", "ur", "ps", "sd", "ug", "yi", "dv", "ckb"]);

interface LocaleWithTextInfo extends Intl.Locale {
  getTextInfo?: () => { direction: "ltr" | "rtl" };
  textInfo?: { direction: "ltr" | "rtl" };
}

export type Direction = "ltr" | "rtl";

export function directionOf(locale: string): Direction {
  const parsed = new Intl.Locale(locale) as LocaleWithTextInfo;
  const info = parsed.getTextInfo?.() ?? parsed.textInfo;
  if (info) return info.direction;
  if (parsed.script && RTL_SCRIPTS.has(parsed.script)) return "rtl";
  return RTL_LANGUAGES.has(parsed.language) ? "rtl" : "ltr";
}
